import { HTMLAttributes, PropsWithChildren } from 'react'

export type DialogFooterProps = HTMLAttributes<HTMLDivElement>

export default function DialogFooter({
  children,
  className,
  ...props
}: PropsWithChildren<DialogFooterProps>) {
  return (
    <footer className={className} {...props}>
      {children}
    </footer>
  )
}
